import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

const actionButtonSx = {
  textTransform: "none",
  borderRadius: "999px",
  fontFamily: '"ABeeZee", sans-serif',
  fontSize: "16px",
  padding: "10px 30px"
};

export default function PushPermissionDialog({ open, onClose, onAllow }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 1.5
        }
      }}
    >
      <DialogTitle sx={{ fontFamily: '"Montserrat", sans-serif', fontWeight: 600 }}>
        Enable push notifications?
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontFamily: '"Montserrat", sans-serif', fontSize: 14 }}>
          We use push notifications to inform you about new messages.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, pt: 1.5 }}>
        <Button
          onClick={onClose}
          sx={{ ...actionButtonSx, color: "#BE9C74" }}
        >
          No, thanks
        </Button>
        <Button
          onClick={onAllow}
          sx={{
            ...actionButtonSx,
            backgroundColor: "#BE9C74",
            color: "#fff",
            "&:hover": { backgroundColor: "#a8835e" }
          }}
          variant="contained"
        >
          Allow
        </Button>
      </DialogActions>
    </Dialog>
  );
}
